var _g, _g2, _path, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientCaptionWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.3934 43.499C45.4725 43.499 36.5846 52.0189 36.5469 62.505H39.2073H42.4799H53.1029L53.1144 56.5633H44.0373C46.3526 52.3398 51.0155 49.4405 56.3934 49.4405C61.7715 49.4405 66.4346 52.3398 68.7498 56.5633H59.7047L59.6933 62.505H70.307H70.841H76.2402C76.2024 52.019 67.3146 43.499 56.3934 43.499Z",
    fill: "#F2F3EE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.1005 49.4409C50.2086 49.4409 44.6016 44.0418 44.6016 37.4055C44.6016 30.7692 50.2086 25.3701 57.1005 25.3701C63.992 25.3701 69.599 30.7692 69.599 37.4055C69.599 44.0418 63.992 49.4409 57.1005 49.4409ZM57.1005 31.3116C53.4846 31.3116 50.5431 34.0452 50.5431 37.4054C50.5431 40.7656 53.4846 43.4992 57.1005 43.4992C60.716 43.4992 63.6575 40.7656 63.6575 37.4054C63.6575 34.0453 60.716 31.3116 57.1005 31.3116Z",
    fill: "#F2F3EE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3487 39.6475C14.2614 39.6475 3.62629 49.9167 3.73124 62.5007C3.7329 62.5023 3.73384 62.5033 3.7355 62.5049H6.05322H9.66683H24.0548L24.0662 56.5632H10.7399C13.2253 50.1655 19.7325 45.589 27.3487 45.589C34.9649 45.589 41.4721 50.1655 43.9575 56.5632H30.6566L30.6451 62.5049H45.0305H49.549H50.9619C50.9635 62.5033 50.9645 62.5023 50.9661 62.5007C51.0711 49.9167 40.436 39.6475 27.3487 39.6475Z",
    fill: "#F2F3EE"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5444 45.5898C19.4795 45.5898 12.918 39.2826 12.918 31.53C12.918 23.7774 19.4795 17.4702 27.5444 17.4702C35.6094 17.4702 42.1709 23.7774 42.1709 31.5299C42.1709 39.2826 35.6094 45.5898 27.5444 45.5898ZM27.5444 23.4119C22.7556 23.4119 18.8596 27.0535 18.8596 31.53C18.8596 36.0066 22.7556 39.6481 27.5444 39.6481C32.3333 39.6481 36.2292 36.0066 36.2292 31.53C36.2292 27.0535 32.3333 23.4119 27.5444 23.4119Z",
    fill: "#F2F3EE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientCaptionWhite);
export default __webpack_public_path__ + "static/media/patient-caption-white.db27a6b3ca3a60d3cb2a11d21c572d90.svg";
export { ForwardRef as ReactComponent };